import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// holidays — วันหยุด (Holiday)
// ============================================================================
export const holidays = sqliteTable("hr_holidays", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  date: text("date").notNull(), // YYYY-MM-DD
  isOptional: integer("is_optional").notNull().default(0),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  hol_company_date_idx: index("hol_company_date_idx").on(table.companyId, table.date),
}));

// Type exports
export type Holiday = typeof holidays.$inferSelect;
export type NewHoliday = typeof holidays.$inferInsert;
